(function() { window.GUID_e21e0c08_b273_4afa_bdfc_af4ced5c5f48 = { getGuid: function() { return "e21e0c08-b273-4afa-bdfc-af4ced5c5f48"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        class AjaxForm {
            constructor(formId) {
                this.formId = formId;
                this.$form = CompuSport.DOM.body.find('#' + this.formId);
                this.$form.data('context', this);
                this.HandleForm();
                CompuSport.DOM.body.trigger("ajaxformready", this);
            }
            HandleForm() {
                let me = this;
                me.$form.off('click.' + me.formId);
                me.$form.off('submit.' + me.formId);
                me.$form /*.on('click.' + me.formId, 'button', function (e) {
                    e.preventDefault();
                    if (me.OnAjaxSubmiting != null) {
                        if (!me.OnAjaxSubmiting.call()) {
                            return;
                        }
                    }
    
                    me.$form.trigger("submit", { action: $(this).val() });
                })*/
                    .on('postform submit.' + me.formId, function (e, extraParams) {
                    e.preventDefault();
                    CompuSport.DOM.body.trigger("ajaxformposting", this);
                    let form = $(this);
                    var validator = form.data('validator');
                    $.validator.unobtrusive.parse(document);
                    var popup = me.$form.data("popupcontext");
                    if (form.valid()) {
                        if (me.OnAjaxSubmiting != null) {
                            if (me.$form.find("[name=UserValidatorToken]").length == 0) {
                                me.OnAjaxSubmiting.call(me);
                                return;
                            }
                        }
                        //if (me.$form.hasClass('SharedEditionOutsidePopup')) {
                        CompuSport.Send.AppendHasChangedElementsToForm(me.$form);
                        //}
                        let formHtml = $(this)[0];
                        let formAction = formHtml.action;
                        if (extraParams != null && extraParams.action != null) {
                            formAction = formAction.replace("action", extraParams.action);
                        }
                        var data = new FormData(formHtml);
                        let ajaxPostSuccess = true;
                        CompuSport.Ajax.PostForm(formAction, data, function (response) {
                            if (response.ajaxRedirect != undefined) {
                                window.location.replace(response.returnUrl);
                            }
                            else {
                                //form.off('submit');
                                let $response = $(response);
                                let $newForm = me.getFormFromResponse($response);
                                //let $newForm = $('form', $response);
                                if ($newForm.length > 0) {
                                    //if (popup != null) {
                                    me.prepareNewForm($newForm, popup);
                                    //}
                                    ajaxPostSuccess = false;
                                    if (extraParams != null && extraParams.refreshOnlyIds != undefined) {
                                        let elements = extraParams.refreshOnlyIds;
                                        let end = elements.length;
                                        for (var i = 0; i < end; i++) {
                                            let existingElement = form.find('#' + elements[i]);
                                            let newElement = $newForm.find('#' + elements[i]);
                                            existingElement.replaceWith(newElement);
                                        }
                                        CallConstructors();
                                    }
                                    else {
                                        form.replaceWith($newForm);
                                        me.$form = form;
                                        me.HandleForm();
                                        $.validator.unobtrusive.parse(document);
                                    }
                                }
                                else {
                                    me.updateOldForm();
                                }
                                if (popup != null) {
                                    popup.DoAfterPost(response, ajaxPostSuccess);
                                }
                                CompuSport.DOM.body.trigger("PopupContentLoaded");
                            }
                            CompuSport.DOM.body.trigger("ajaxformposted", this);
                            if (ajaxPostSuccess) {
                                CompuSport.DOM.body.trigger("ajaxformpostsuccess", this);
                            }
                        });
                    }
                });
            }
            getFormFromResponse($response) {
                if ($response.length > 1) {
                    return $response.filter('form');
                }
                else {
                    return $('form', $response);
                }
            }
            prepareNewForm($newform, popupContext) {
                let me = this;
                if (popupContext != null) {
                    $('header', $newform).remove();
                    $('footer', $newform).remove();
                    $('.PopupButtons', $newform).remove();
                    $newform.data("popupcontext", popupContext);
                }
                else {
                    $newform.addClass("SharedEditionOutsidePopup");
                }
                $newform.append(me.$form.find('.HasChangedContainer'));
                //$newform.data("context", me.$form.data("context"))
            }
            updateOldForm() {
                let me = this;
                me.$form.find('.HasChangedContainer').remove();
                me.$form.find('.validation-summary-errors').remove();
                var inputs = me.$form.find('.IHasChanged');
                $.each(inputs, function (e) {
                    var control = $(this).data('context');
                    if (control != undefined) {
                        control.UpdateStartValue();
                    }
                });
            }
        }
        Controls.AjaxForm = AjaxForm;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=AjaxForm.js.map
